import { render, staticRenderFns } from "./PatientDataTable.vue?vue&type=template&id=c6e10b5e&scoped=true"
import script from "./PatientDataTable.vue?vue&type=script&lang=js"
export * from "./PatientDataTable.vue?vue&type=script&lang=js"
import style0 from "./PatientDataTable.vue?vue&type=style&index=0&id=c6e10b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e10b5e",
  null
  
)

export default component.exports